// extracted by mini-css-extract-plugin
module.exports = {"loadingStyle":"ResourceAllocation_loadingStyle__rDoKz"};